module.exports = __webpack_public_path__ + "img/bannerGreen.4b46cfa9.jpg";